<template>
  <div id="app">
    <router-view ref="app" />
    <div v-if="noticePopups.length" class="notice-popup-layer">
      <section
        v-for="(popup, index) in noticePopups"
        :key="popup.idx"
        class="notice-popup-card"
        :class="{ 'notice-popup-card--plain': !popup.basicFrame }"
        :style="getPopupCardStyle(popup, index)"
      >
        <header class="notice-popup-header">
          <strong>{{ popup.title || "공지" }}</strong>
          <button
            type="button"
            class="notice-popup-close"
            @click="handlePopupClose(popup)"
          >
            닫기
          </button>
        </header>
        <div
          class="notice-popup-body"
          :style="getPopupBodyStyle(popup)"
          v-html="popup.contentHtml"
        />
        <footer class="notice-popup-footer">
          <label class="notice-popup-hide">
            <input v-model="popup.hideToday" type="checkbox" />
            오늘 하루 보지 않기
          </label>
          <button
            type="button"
            class="notice-popup-close-btn"
            @click="handlePopupClose(popup)"
          >
            확인
          </button>
        </footer>
      </section>
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  data() {
    return {
      noticePopups: [],
    };
  },
  mounted() {
    window.$vm = this.$refs.app;
    this.loadNoticePopups();
  },
  methods: {
    async loadNoticePopups() {
      try {
        const response = await axios.get("/board/notices/popups", {
          params: {
            site: "uni",
            homeVersion: "modern",
          },
        });
        const items = Array.isArray(response.data && response.data.items)
          ? response.data.items
          : [];

        this.noticePopups = items
          .filter((popup) => !this.isPopupHiddenToday(popup.cookieKey))
          .map((popup) => ({
            ...popup,
            hideToday: false,
          }));
      } catch (error) {
        console.error("Failed to load notice popups:", error);
      }
    },
    getPopupStorageKey(cookieKey) {
      return `notice-popup-hide:${cookieKey}`;
    },
    getTodayKey() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const date = String(now.getDate()).padStart(2, "0");
      return `${year}-${month}-${date}`;
    },
    isPopupHiddenToday(cookieKey) {
      if (!cookieKey) return false;

      try {
        return (
          localStorage.getItem(this.getPopupStorageKey(cookieKey)) ===
          this.getTodayKey()
        );
      } catch (error) {
        return false;
      }
    },
    rememberPopupHiddenToday(cookieKey) {
      if (!cookieKey) return;

      try {
        localStorage.setItem(
          this.getPopupStorageKey(cookieKey),
          this.getTodayKey(),
        );
      } catch (error) {
        console.error("Failed to persist popup hide state:", error);
      }
    },
    handlePopupClose(popup) {
      if (popup && popup.hideToday) {
        this.rememberPopupHiddenToday(popup.cookieKey);
      }

      this.noticePopups = this.noticePopups.filter(
        (item) => item.idx !== popup.idx,
      );
    },
    getPopupCardStyle(popup, index) {
      const width = Math.max(280, Number(popup && popup.width) || 520);
      return {
        width: `${width}px`,
        zIndex: 5000 + index,
        top: `${32 + index * 18}px`,
        left: `${24 + index * 18}px`,
      };
    },
    getPopupBodyStyle(popup) {
      const height = Math.max(220, Number(popup && popup.height) || 470);
      return {
        height: `${height}px`,
      };
    },
  },
};
</script>
<style scoped>
.notice-popup-layer {
  position: fixed;
  inset: 0;
  z-index: 5000;
  pointer-events: none;
}

.notice-popup-card {
  position: fixed;
  max-width: calc(100vw - 32px);
  background: #fff;
  border: 1px solid rgba(10, 34, 57, 0.18);
  box-shadow: 0 22px 54px rgba(15, 27, 43, 0.2);
  border-radius: 18px;
  overflow: hidden;
  pointer-events: auto;
}

.notice-popup-card--plain {
  background: transparent;
  border: 0;
  box-shadow: none;
}

.notice-popup-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 18px;
  background: #f4efe7;
  color: #213547;
  font-size: 15px;
}

.notice-popup-body {
  max-height: calc(100vh - 180px);
  overflow: auto;
  background: #fff;
}

.notice-popup-body >>> img {
  max-width: 100%;
  height: auto;
}

.notice-popup-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  border-top: 1px solid rgba(10, 34, 57, 0.1);
  background: #fffaf4;
}

.notice-popup-hide {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #5a6573;
}

.notice-popup-close,
.notice-popup-close-btn {
  border: 0;
  background: #213547;
  color: #fff;
  border-radius: 999px;
  padding: 8px 14px;
  font-size: 12px;
  cursor: pointer;
}

.notice-popup-close {
  padding: 6px 12px;
  background: rgba(33, 53, 71, 0.88);
}

@media (max-width: 767px) {
  .notice-popup-card {
    left: 16px !important;
    right: 16px;
    width: auto !important;
    max-width: none;
    top: auto !important;
    bottom: 16px;
  }

  .notice-popup-body {
    height: auto !important;
  }
}
</style>
